import Vue from 'vue'
import Router from 'vue-router'
import {RouterTabRoutes} from 'vue-router-tab'
import $store from '@/store'
import {readLocal} from '@/assets/js/common'
import Frame from '../page/layout/frame'

// 异步加载页面组件
const importPage = view => () => import(`../page/${view}.vue`)
Vue.use(Router)

if (readLocal('userToken', 'token')) {
  $store.commit('setToken', readLocal('userToken', 'token'))
}

$store.commit('setLogin', true)

let constantRouterMap = [
  {
    path: '/assist',
    component: importPage('assist/index'),
    children: [
      {
        path: 'login',
        component: importPage('assist/login/index')
      }
    ],
    redirect: '/assist/login'
  },
  {
    path: '/login',
    redirect: '/assist/login'
  }
]

let syncRouters = menuList => {
  let routes = []
  menuList.forEach(o => {
    let url = o['Url'].toLowerCase()
    if (o.children && o.children.length) {
      o.children.forEach(c => {
        routes.push({
          path: url + '/' + c['Url'],
          name: c['Id'],
          component: importPage('main/' + url + '/' + c['Url'].toLowerCase()),
          meta: {
            title: c['Name']
          }
        })
      })
    }
  })
  return [
    {
      path: '/',
      component: Frame,
      children: [
        ...RouterTabRoutes,
        ...routes,
        {
          path: '/',
          name: 'home',
          component: importPage('main/home'),
          meta: {
            icon: 'el-icon-monitor',
            title: '首页',
            closable: false
          }
        },
        {
          path: 'assess/WeiPai/action',
          name: 'WeiPaiAction',
          component: importPage('main/assess/action/weiPai'),
          meta: {
            title: '新建委派单'
          }
        },
        {
          path: 'assess/WeiPai/action/:id',
          name: 'WeiPaiActionEdit',
          component: importPage('main/assess/action/weiPai'),
          meta: {
            title: '编辑委派单'
          }
        },
        {
          path: 'assess/WeiPai/flow/:id',
          name: 'WeiPaiFlow',
          component: importPage('main/assess/action/pgFlow'),
          meta: {
            title: '评估流程'
          }
        },
        {
          path: 'assess/WeiPai/flowDetail/:id',
          name: 'WeiPaiFlowDetail',
          component: importPage('main/assess/action/flowDetail'),
          meta: {
            title: '评估报告信息'
          }
        },
        {
          path: 'assess/inquiry/action',
          name: 'InquiryAction',
          component: importPage('main/assess/action/inquiry'),
          meta: {
            title: '新建询价'
          }
        },
        {
          path: 'assess/inquiry/action/:id',
          name: 'InquiryActionEdit',
          component: importPage('main/assess/action/inquiry'),
          meta: {
            title: '编辑询价'
          }
        },
        {
          path: 'assess/inquiry/import',
          name: 'inquiryImport',
          component: importPage('main/assess/page/import'),
          meta: {
            title: '询价导入'
          }
        },
        {
          path: 'demolition/manage/action',
          name: 'createCQ',
          component: importPage('main/demolition/action/create_action'),
          meta: {
            title: '新建拆迁委派单'
          }
        },
        {
          path: 'demolition/manage/action/:id',
          name: 'createCQEdit',
          component: importPage('main/demolition/action/create_action'),
          meta: {
            title: '编辑拆迁委派单'
          }
        },
        {
          path: 'demolition/head/action/:id',
          name: 'perfectAction',
          component: importPage('main/demolition/action/perfect_action'),
          meta: {
            title: '完善拆迁委派单'
          }
        },
        {
          path: 'demolition/WPD_Detail/:id',
          name: 'WPDDetail',
          component: importPage('main/demolition/page/wpd_detail'),
          meta: {
            title: '拆迁委派单详情'
          }
        },
        {
          path: 'demolition/import/:id',
          name: 'CSImport',
          component: importPage('main/demolition/page/import'),
          meta: {
            title: '上传测算'
          }
        },
        {
          path: 'demolition/CS_Detail/:id',
          name: 'CSDetail',
          component: importPage('main/demolition/page/cs_detail'),
          meta: {
            title: '测算详情'
          }
        },
        {
          path: 'demolition/JX_Manage/:id',
          name: 'demolitionJXManage',
          component: importPage('main/demolition/page/jx_manage'),
          meta: {
            title: '项目绩效'
          }
        },
        {
          path: 'demolition/JX_User/:id',
          name: 'demolitionJXUser',
          component: importPage('main/demolition/page/jx_user'),
          meta: {
            title: '人员月度绩效'
          }
        },
        {
          path: 'demolition/JX_My/:id',
          name: 'JXMy',
          component: importPage('main/demolition/page/jx_my'),
          meta: {
            title: '我的绩效'
          }
        },
        {
          path: 'demolition/measureRecord/:id',
          name: 'measureRecord',
          component: importPage('main/demolition/measure_common'),
          meta: {
            title: '测算记录'
          }
        },
        {
          path: 'archive/demolition/:id',
          name: 'archiveDemolition',
          component: importPage('main/archive/page/demolition'),
          meta: {
            title: '测算列表'
          }
        },
        {
          path: 'demolition/charge/:id',
          name: 'demolitionCharge',
          component: importPage('main/demolition/page/chargeDetail'),
          meta: {
            title: '拆迁收费单详情'
          }
        },
        {
          path: 'demolition/JX_Manage/set/:id',
          name: 'jxSet',
          component: importPage('main/demolition/page/jx_set'),
          meta: {
            title: '项目绩效设置'
          }
        },
        {
          path: 'assess/charge/:id',
          name: 'assessCharge',
          component: importPage('main/assess/page/chargeDetail'),
          meta: {
            title: '评估收费单详情'
          }
        },
        {
          path: 'finance/:id/payable',
          name: 'payableDetail',
          component: importPage('main/finance/page/payableDetail'),
          meta: {
            title: '收款项目详情'
          }
        },
        {
          path: 'gongzhang/contract/action',
          name: 'createContract',
          component: importPage('main/gongzhang/contractAction'),
          meta: {
            title: '新建合同文件'
          }
        },
        {
          path: 'gongzhang/contract/action/:id',
          name: 'createContractEdit',
          component: importPage('main/gongzhang/contractAction'),
          meta: {
            title: '编辑合同文件'
          }
        },
        {
          path: 'gongzhang/contract/detail/:id',
          name: 'detailContract',
          component: importPage('main/gongzhang/contractDetail'),
          meta: {
            title: '合同文件详情'
          }
        },
        {
          path: 'gongzhang/expense/action',
          name: 'createBaoXiao',
          component: importPage('main/gongzhang/expenseAction'),
          meta: {
            title: '新建款项报销'
          }
        },
        {
          path: 'gongzhang/expense/action/:id',
          name: 'createBaoXiaoEdit',
          component: importPage('main/gongzhang/expenseAction'),
          meta: {
            title: '编辑款项报销'
          }
        },
        {
          path: 'gongzhang/expense/detail/:id',
          name: 'detailBaoXiao',
          component: importPage('main/gongzhang/contractDetail'),
          meta: {
            title: '款项报销详情'
          }
        },
        {
          path: 'demolition/holiday/action',
          name: 'demolitionHoliday',
          component: importPage('main/demolition/action/holiday'),
          meta: {
            title: '新建节假日'
          }
        },
        {
          path: 'demolition/holiday/action/:id',
          name: 'demolitionHolidayEdit',
          component: importPage('main/demolition/action/holiday'),
          meta: {
            title: '编辑节假日'
          }
        },
        {
          path: 'demolition/coefficient/action',
          name: 'demolitionCoefficient',
          component: importPage('main/demolition/action/coefficient'),
          meta: {
            title: '新建绩效系数'
          }
        },
        {
          path: 'demolition/coefficient/action/:id',
          name: 'demolitionCoefficientEdit',
          component: importPage('main/demolition/action/coefficient'),
          meta: {
            title: '编辑绩效系数'
          }
        },
        {
          path: 'manage/news/action',
          name: 'createNews',
          component: importPage('main/manage/action/news'),
          meta: {
            title: '新建信息'
          }
        },
        {
          path: 'manage/news/action/:id',
          name: 'editNews',
          component: importPage('main/manage/action/news'),
          meta: {
            title: '编辑信息'
          }
        },
        {
          path: 'manage/news/detail/:id',
          name: 'newsDetail',
          component: importPage('main/manage/page/newsDetail'),
          meta: {
            title: '信息详情'
          }
        },
        {
          path: 'demolition/TH/action',
          name: 'createTH',
          component: importPage('main/thjg/th_action'),
          meta: {
            title: '新建投后项目'
          }
        },
        {
          path: 'demolition/TH/action/:id',
          name: 'createTHEdit',
          component: importPage('main/thjg/th_action'),
          meta: {
            title: '编辑投后项目'
          }
        },
        {
          path: 'th/charge/:id',
          name: 'thCharge',
          component: importPage('main/demolition/page/chargeDetail'),
          meta: {
            title: '投后收费单详情'
          }
        },
        {
          path: 'th/weekly/:id',
          name: 'thweekly',
          component: importPage('main/thjg/th_weekly'),
          meta: {
            title: '投后周报月报'
          }
        },
        {
          path: 'weeklydetail/:id',
          name: 'weeklydetail',
          component: importPage('main/thjg/th_weeklydetail'),
          meta: {
            title: '报告详情'
          }
        },
        {
          path: 'th/th_gdDetail/:id',
          name: 'thgd',
          component: importPage('main/thjg/th_gdDetail'),
          meta: {
            title: '投后存档'
          }
        },
        {
          path: 'zhsw/action',
          name: 'createzhsw',
          component: importPage('main/zhsw/action'),
          meta: {
            title: '新建事务委派'
          }
        },
        {
          path: 'zhsw/action/:id',
          name: 'createzhswEdit',
          component: importPage('main/zhsw/action'),
          meta: {
            title: '编辑事务委派'
          }
        },
        {
          path: 'zhswgd/:id',
          name: 'zhswgd',
          component: importPage('main/zhsw/gdDetail'),
          meta: {
            title: '事务成果上传'
          }
        },
        {
          path: 'zhswjx/:id',
          name: 'zhswjx',
          component: importPage('main/zhsw/jxDetail'),
          meta: {
            title: '事务绩效分配'
          }
        },
        {
          path: 'weekly/:id',
          name: 'weekly',
          component: importPage('main/manage/weekly'),
          meta: {
            title: '人员周报'
          }
        },
        {
          path: 'gujiashi',
          name: 'createGJS',
          component: importPage('main/manage/gujiashiadd'),
          meta: {
            title: '新增估价师'
          }
        },
        {
          path: 'gujiashi/:id',
          name: 'editGJS',
          component: importPage('main/manage/gujiashiadd'),
          meta: {
            title: '修改估价师'
          }
        },
        {
          path: 'fapiao',
          name: 'fapiao',
          component: importPage('main/gongzhang/fapiao'),
          meta: {
            title: '发票'
          }
        }
      ]
    },
    {
      path: '/',
      redirect: '/home'
    }
  ]
}

const createRouter = () => new Router({
  linkActiveClass: 'active',
  linkExactActiveClass: '',
  routes: constantRouterMap
})

const router = createRouter()

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

router.beforeEach((to, from, next) => {
  if (to.path.indexOf('/assist') >= 0) { // 非验证页面
    if (to.matched.length === 0) {
      $store.commit('setLoading', false)
      next('/assist/login')
    } else {
      next()
    }
  } else {
    if ($store.state.base.isLogin) {
      $store.commit('setLogin', false)
      $store.commit('setLoading', true)
      $store.dispatch('getMenu').then(res => {
        resetRouter()
        router.addRoutes(syncRouters(res))
        next({...to, replace: true})
      })
    } else {
      if (to.matched.length) {
        next()
      } else {
        next('/')
      }
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js